import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { NavLink, useLocation } from 'react-router-dom';
import LanguageButton from '../../common/language-button/LanguageButton';
import Logo from '../../common/logo/Logo';
import mainAppBarLinks from './mainAppBarLinks';
import './MainAppBarLg.scss';
import routerLinks from '../app/routerLinks';

import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0'
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5)
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
      }
    }
  }
}));

function CustomizedMenus() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { t } = useTranslation();
  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls="demo-customized-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}>
        <span>{t('main_app_bar_links.Dashboard')}</span>
        <svg
          style={{ margin: '0px 5px' }}
          xmlns="http://www.w3.org/2000/svg"
          fill="#fff"
          version="1.1"
          id="Layer_1"
          width="20px"
          height="20px"
          viewBox="0 0 100 100"
          enableBackground="new 0 0 100 100">
          <g>
            <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58   c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022   c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z" />
          </g>
        </svg>
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        <MenuItem onClick={handleClose} disableRipple>
          <a
            href="https://fatoorah.fatoorah.sa"
            target="_blank"
            rel="noreferrer"
            className="linkle">
            {t(`request_project_page.request_project_form.activity_id.label2`)}
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          <a href="http://services.fatoorah.sa" target="_blank" rel="noreferrer" className="linkle">
            {t(`request_project_page.request_project_form.activity_id.label3`)}
          </a>
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
function CustomizedMenusFeatured() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { t } = useTranslation();
  return (
    <div>
      <Button
        id="demo-customized-button-features"
        aria-controls="demo-customized-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disableElevation
        onClick={handleClick}>
        <span>{t('main_app_bar_links.features')}</span>
        <svg
          style={{ margin: '0px 5px' }}
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
          version="1.1"
          id="Layer_1"
          width="20px"
          height="20px"
          viewBox="0 0 100 100"
          enableBackground="new 0 0 100 100">
          <g>
            <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58   c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022   c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z" />
          </g>
        </svg>
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        <MenuItem onClick={handleClose} disableRipple>
          <a href="https://fatoorah.sa/sales/" target="_blank" rel="noreferrer" className="linkle">
            {t('features_navs.features_navs-1')}
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          <a href="https://fatoorah.sa/pos/" target="_blank" rel="noreferrer" className="linkle">
            {t('features_navs.features_navs-2')}
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          <a
            href="https://fatoorah.sa/inventory/"
            target="_blank"
            rel="noreferrer"
            className="linkle">
            {t('features_navs.features_navs-3')}
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          <a
            href="https://fatoorah.sa/employees/"
            target="_blank"
            rel="noreferrer"
            className="linkle">
            {t('features_navs.features_navs-4')}
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          <a
            href="https://fatoorah.sa/data-and-reports/"
            target="_blank"
            rel="noreferrer"
            className="linkle">
            {t('features_navs.features_navs-5')}
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          <a
            href="https://fatoorah.sa/archives/"
            target="_blank"
            rel="noreferrer"
            className="linkle">
            {t('features_navs.features_navs-6')}
          </a>
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
function CustomizedMenusAbout() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { t } = useTranslation();
  return (
    <div>
      <Button
        id="demo-customized-button-features"
        aria-controls="demo-customized-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disableElevation
        onClick={handleClick}>
        <span>{t('main_app_bar_links.about')}</span>
        <svg
          style={{ margin: '0px 5px' }}
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
          version="1.1"
          id="Layer_1"
          width="20px"
          height="20px"
          viewBox="0 0 100 100"
          enableBackground="new 0 0 100 100">
          <g>
            <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58   c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022   c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z" />
          </g>
        </svg>
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        <MenuItem onClick={handleClose} disableRipple>
          <a href="https://fatoorah.sa/about/" target="_blank" rel="noreferrer" className="linkle">
            {t('about_navs.about_navs-1')}
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          <a
            href="https://fatoorah.sa/contact/"
            target="_blank"
            rel="noreferrer"
            className="linkle">
            {t('about_navs.about_navs-2')}
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          <a
            href="https://fatoorah.sa/pricing/"
            target="_blank"
            rel="noreferrer"
            className="linkle">
            {t('about_navs.about_navs-3')}
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          <a href="https://fatoorah.sa/docs/" target="_blank" rel="noreferrer" className="linkle">
            {t('about_navs.about_navs-4')}
          </a>
        </MenuItem>
      </StyledMenu>
    </div>
  );
}

const MainAppBarLg = ({ className }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const hanldeClick = (section) => () => {
    if (pathname === routerLinks.homePage && section !== '') {
      document.querySelector(`.${section}`).scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      history.push(routerLinks.HelpFatorah, {});
    }
  };

  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === routerLinks.contactPage) {
    } else {
    }
  }, [pathname]);

  const renderNavLinks = () => {
    return (
      <ul>
        {mainAppBarLinks(t, pathname).map(({ id, name, link }) => (
          <li
            key={id}
            className={`${
              pathname === routerLinks.PolicyPage ||
              pathname === routerLinks.returnPage ||
              pathname === routerLinks.payPage ||
              pathname === routerLinks.ConditionPage ||
              pathname === routerLinks.contactPage
                ? 'Active'
                : 'notActive'
            }`}>
            {/* <span 
                  style={{cursor:'pointer'}}
                  className="active-link" 
                  onClick={() => {
                    window.location.replace(link);
                  }}
              >
                  {name}
                  <div className="active-img-wrap"></div>
              </span> */}
            <a target="_blank" rel="noreferrer" href={link}>
              {name}
              <div className="active-img-wrap"></div>
            </a>
          </li>
        ))}
      </ul>
    );
  };
  return (
    <div className={className}>
      <div className="custom-container">
        <div className="nav-content-wrapper">
          <Logo className="main-app-bar-logo" />
          <div className="nav-lang-wrapper">
            {renderNavLinks()}
            {/* <a href="https://fatoorah.fatoorah.sa" target="_blank" rel="noreferrer">
              <button className="dashborad">{t('main_app_bar_links.Dashboard')}</button>
            </a>  */}
            <CustomizedMenusFeatured />
            <CustomizedMenusAbout />
            <CustomizedMenus />
            {/* <LanguageButton /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainAppBarLg;
